import axios from "axios";
import { API_URL } from "../components/config";
import { getAuthHeaders } from "../components/commonfunctions/useAuthHelpers";

export async function createConversation() {
  const { data } = await axios.post(
    `${API_URL}/api/chat/conversations`,
    {},
    { headers: getAuthHeaders() }
  );
  return data;
}

export async function getConversationHistory(conversationId) {
  const { data } = await axios.get(
    `${API_URL}/api/chat/history/${conversationId}`,
    { headers: getAuthHeaders() }
  );
  return data;
}

export async function getLatestConversation() {
  const { data } = await axios.get(
    `${API_URL}/api/chat/latest`,
    { headers: getAuthHeaders() }
  );
  return data;
}

export async function sendChatMessage(payload) {
  const { data } = await axios.post(
    `${API_URL}/api/chat/send`,
    payload,
    { headers: getAuthHeaders() }
  );
  return data;
}

export async function exportChatExcel(payload) {
  const response = await axios.post(
    `${API_URL}/api/chat/export-excel`,
    payload,
    {
      headers: getAuthHeaders(),
      responseType: "blob", // ✅ CRITICAL
    }
  );
  return response.data;
}